<template>
  <oversea-billing ref="overseaBilling" :context="context" :action="action" :view-source="viewSource" :location="location" :enable-ui-custom="enableUiCustom" :page-type="pageType" />
</template>

<script>
import OverseaBilling from './overseaBilling'

export default {
  name: 'TabOverseaBill',
  components: { OverseaBilling },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    },
    location: { type: String, required: false },
    enableUiCustom: { type: Boolean, default: false }, // 是否启用UI自定义
    pageType: { type: Number, default: 0 } // UI自定义页签类型
  },
  data() {
    return {
      masterFlag: false
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.masterFlag = row.masterFlag || false
      if (!isRefresh && this.isEdit) {
        return
      }
      if (!row.uuid) {
        return
      }
      this.job = row
      // 调用子组件
      this.$refs.overseaBilling.onShow(row)
    },
    // 打印
    getPrintData() {
      // 调用子组件
      this.$refs.overseaBilling.getPrintData()
      return null
    }
  }
}
</script>

<style>
</style>
